import UserPage, {IUserPageAttrs} from "./UserPage";
import NotificationList from './NotificationList';
import Mithril from "mithril";
import type User from '../../common/models/User';
import NotificationListState from "../states/NotificationListState";

/**
 * 消息通知【个人中心】
 */
export default class NotificationUserPage extends UserPage<IUserPageAttrs, NotificationListState> {
  protected notifications: NotificationListState;

  oninit(vnode: Mithril.Vnode<IUserPageAttrs, this>) {
    super.oninit(vnode);
    this.loadUser(m.route.param('username'));
  }

  show(user: User): void {
    super.show(user);

    this.notifications = new NotificationListState();
    this.notifications.refresh();
  }

  content() {
    return (
      <div className="NotificationUserPage">
        <NotificationList state={this.notifications}></NotificationList>
      </div>
    );
  }
}
